import {Provider} from '_redux/calendar/calendar.types';

export enum ModalType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  None = 'none',
}

export enum AppointmentDurations {
  ten = '10',
  thirty = '30',
  forty_five = '45',
  sixty = '60',
}

export type Time = {
  value: string; //should be date-time string
  rawTime: string; //should be date-time string
  disabled: boolean;
};

export type FieldValues = {
  providerId: string;
  clientId: string;
  selectedDays: Date;
  time: Time;
  duration: AppointmentDurations;
  calendarId: string;
};

export enum AppointmentTypes {
  doctor_consultation = 'doctor_consultation',
  video_call_with_therapist = 'video_call_with_therapist',
}

export enum ProviderType {
  Therapist = 'Therapist',
  Prescriber = 'Prescriber',
}

export enum ProviderRole {
  therapist = 'therapist',
  prescriber = 'prescriber',
}

export type SessionType = {
  label: string;
  value: AppointmentDurations;
  type: AppointmentTypes;
};

export interface FetchProvidersResponse<T extends Provider> {
  message: {
    results: T[];
    currentPage: number;
    resultsPerPage: number;
    totalResults: number;
    totalPages: number;
    hasMore: boolean;
  };
}

export enum PresetRange {
  AllTime = 'all-time',
  CurrentYear = 'current-year',
  Last6Months = 'last-6-months',
  Last3Months = 'last-3-months',
  LastMonth = 'last-month',
  CurrentMonth = 'current-month',
  NextMonth = 'next-month',
  Next3Months = 'next-3-months',
}

export type InitialDateOptions = {
  label: string;
  value: PresetRange;
  active: boolean;
};

export type SelectOption = {label: string; value: string};

export type SelectedType = SelectOption | SelectOption[] | null;

export type DateRange = {
  from?: Date;
  to?: Date;
  label?: string;
  timezone?: string;
};
